export type { LegalDocument, LegalDocumentSection } from "#legal-document";
export { PRIVACY_POLICY_DOCUMENT } from "#privacy-policy-document";
export { TERMS_OF_SERVICE_DOCUMENT } from "#terms-of-service-document";
